import { createSvgIcon } from '@mui/material';

const IconMagicButton = createSvgIcon(
  <path d="M10 18.8125L7.5 13.377L2 10.9062L7.5 8.43555L10 3L12.5 8.43555L18 10.9062L12.5 13.377L10 18.8125ZM18 20.7891L16.75 18.0713L14 16.8359L16.75 15.6006L18 12.8828L19.25 15.6006L22 16.8359L19.25 18.0713L18 20.7891Z" />,
  'magic_button',
);

export default IconMagicButton;
